import React from 'react';
import { BodyText, Icon, Link } from '@paypalcorp/pp-react';
import getLocaleMessages from '../utils/localesMessages';
import PropTypes from 'prop-types';
import { trackEventWithData } from '../utilsV3/analytics';

const { buttonFeedback } = getLocaleMessages('buttonsV3/common');

function DonateButtonFeedback({ currentStep, fptiSpec }) {
  const handleQualtrics = () => {
    if (typeof PAYPAL !== 'undefined' && window.PAYPAL.analytics) {
      trackEventWithData(fptiSpec, { step: currentStep });

      window.PAYPAL.analytics.reloadQualtrics(
        'donatenodeweb-merchant-qualtrics'
      );
    }
  };

  return (
    <BodyText className="feedback">
      <Link href="#" onClick={handleQualtrics}>
        <Icon name="chat" size="sm" />
        {buttonFeedback}
      </Link>
    </BodyText>
  );
}

DonateButtonFeedback.propTypes = {
  currentStep: PropTypes.number,
  fptiSpec: PropTypes.object,
};

export default DonateButtonFeedback;
